<template>
  <div class="calendar">
    <table cellpadding="5">
      <thead>
      <tr>
        <td v-for="week in weeks" class="week" :class="{'dayofrest':week==='日'||week==='六'}">{{week}}</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(dayItem,k1) in dayinfo" style="{'animation-delay',(k1*30)+'ms'}" :key="k1">
        <td v-for="(child,k2) in dayItem" :key="k2">
          <div class="g-daybox" :class="{'f-onNowDate':child.isNowday,'f-onSign':chooseInfo === new Date(`${child.year}/${child.month + 1}/${child.date}`).format('yyyy-MM-dd'),'f-dayofrest':child.dayofrest,'f-isAfterTomorrow':child.isAfterTomorrow,'f-isTomorrow':child.isTomorrow,'f-isBeforeDate':child.isBeforeDate}" @click="goSign(k1,k2,child)"><!--@click="goSign(k1,k2,child)"-->
            {{child.localmonth ? child.day : ''}}
            <i class="iconfont icon-duihao"></i>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import * as getData from '../service/getData'
  import * as mobile from '../config/mUtils'
  import {mapState, mapMutations,mapActions} from 'vuex'
  import calendar from '../assets/js/calendar'
  export default {
    props: ['nowMonth','defaultDate','limitTime','chooseBeforeDate'],
    data () {
      return {
        impotTime: '',
        dayinfo: [],
        weeks: ['日','一', '二', '三', '四', '五', '六'],
        chooseInfo: '',
      }
    },
    mounted () {
    },
    components: {
    },
    computed: {

    },
    methods: {
      goSign (k1,k2,child) {
        /*if (child.localmonth) {
          return
        }*/
        if (this.chooseBeforeDate && !child.isBeforeDate) {//选择今日之前的日子
          return
        }
        if (!child.localmonth) {
          return
        }
        if (this.limitTime && (new Date(`${child.year}/${child.month + 1}/${child.date}`) - new Date(this.limitTime) < 0)) {
          return
        }
        const val = new Date(`${child.year}/${child.month + 1}/${child.date}`).format('yyyy-MM-dd');
        if (this.chooseInfo === val) {
          this.chooseInfo = '';
        } else {
          this.chooseInfo = val;
        }
        this.$emit('dateInfo', this.chooseInfo);
      },
      init () {
        let showdate = new Date(this.impotTime);
        let y = showdate.getFullYear();/*年*/
        let m = showdate.getMonth();/*月*/
        this.render(y,m)
      },
      render (y,m) {/*渲染日期*/
        let firstDayOfMonth = new Date(y, m, 1).getDay()         //当月第一天是周几
        let lastDateOfMonth = new Date(y, m + 1, 0).getDate()    //当月最后一天
        let line = 0;
        let temp = [];
        for (let i = 1; i <= lastDateOfMonth; i++) {
          let day = new Date(y, m, i).getDay(); //返回星期几（0～6）
          let date = i;
          let lunar = this.getLunarInfo(y,m,i);
          if (day === 0) {
            temp[line] = [];
          } else if (i === 1) {
            temp[line] = [];
          }
          let isNowday = false;
          if (new Date().format('yyyy-MM-dd') === new Date(y,m,i).format('yyyy-MM-dd')) {
            isNowday = true;
            date = '今天';
          }
          let isTomorrow = false;
          if (new Date(new Date().setDate(new Date().getDate() + 1)).format('yyyy-MM-dd') === new Date(y,m,i).format('yyyy-MM-dd')) {
            isTomorrow = true;
            date = '明天';
          }
          let isAfterTomorrow = false;
          if (new Date(new Date().setDate(new Date().getDate() + 2)).format('yyyy-MM-dd') === new Date(y,m,i).format('yyyy-MM-dd')) {
            isAfterTomorrow = true;
            date = '后天';
          }
          let dayofrest = false;
          if (day === 0 || day === 6) {
            dayofrest = true;
          }
          let isBeforeDate = false;
          if (new Date(y,m,i) - new Date() < -(3600 * 24 * 1000)) {
            isBeforeDate = true;
          }
          temp[line].push({
            date: i,/*几号*/
            day: date,/*几号*/
            week: day,/*周几*/
            year: y,
            month: m,
            isBeforeDate: isBeforeDate,//过去的日子
            isNowday: isNowday,//今天
            isTomorrow: isTomorrow,//明天
            isAfterTomorrow: isAfterTomorrow,//后天
            localmonth: true,/*是否是当月*/
            dayofrest: dayofrest,/*是否为休息日*/
            configure: false,/*是否已配置*/
            IMonthCn: lunar.IMonthCn,/*农历正月*/
            IDayCn: lunar.IDayCn,/*农历十四*/
            nowNewDate: new Date(`${y}/${m}/${i}`),//当前的new Date
          });
          if (day === 6) {
            line++;
          }
        }
        //console.log(temp,123);
        //补全数组，
        /*先补后7个*/
        let lartWeekOfMonth = new Date(y,m,lastDateOfMonth).getDay();/*得到当月的最后一天是周几*/
        if (lartWeekOfMonth !== 6) {
          for (let i = 1;i <= 10;i++) {
            let day = new Date(y, m + 1, i).getDay(); //返回星期几（0～6）
            let lunar = this.getLunarInfo(y,m + 1,i);
            let isBeforeDate = false;
            if (new Date(y,m + 1,i) - new Date() < -(3600 * 24 * 1000)) {
              isBeforeDate = true;
            }
            temp[temp.length - 1].push({
              date: i,/*几号*/
              day: i,/*几号*/
              week: day,/*周几*/
              year: y,
              month: m + 1,
              isBeforeDate: isBeforeDate,//过去的日子
              isNowday: false,//今天
              isTomorrow: false,//明天
              isAfterTomorrow: false,//后天
              localmonth: false,/*是否是当月*/
              dayofrest: false,/*是否为休息日*/
              configure: false,/*是否已配置*/
              IMonthCn: lunar.IMonthCn,/*农历正月*/
              IDayCn: lunar.IDayCn,/*农历十四*/
              nowNewDate: new Date(`${y}/${m}/${i}`),//当前的new Date
            });
            if (day === 6) {
              break
            }
          }
        }
        /*不全前七个*/
        let beforeDateOfMonth = new Date(y, m, 0).getDate()    //前一个月的最后一天
        if(firstDayOfMonth !== 0) {
          for(let i = beforeDateOfMonth;i > 20; i--) {
            let day = new Date(y, m - 1, i).getDay(); //返回星期几（0～6）
            let lunar = this.getLunarInfo(y,m - 1,i);
            let isBeforeDate = false;
            if (new Date(y,m - 1,i) - new Date() < -(3600 * 24 * 1000)) {
              isBeforeDate = true;
            }
            temp[0].unshift({
              date: i,/*几号*/
              day: i,/*几号*/
              week: day,/*周几*/
              year: y,
              month: m - 1,
              isBeforeDate: isBeforeDate,//过去的日子
              isNowday: false,//今天
              isTomorrow: false,//明天
              isAfterTomorrow: false,//后天
              localmonth: false,/*是否是当月*/
              dayofrest: false,/*是否为休息日*/
              configure: false,/*是否已配置*/
              IMonthCn: lunar.IMonthCn,/*农历正月*/
              IDayCn: lunar.IDayCn,/*农历十四*/
              nowNewDate: new Date(`${y}/${m}/${i}`),//当前的new Date
            });
            if (day === 0) {
              break
            }
          }
        }
        //console.log(temp,456);
        this.dayinfo = temp;
      },
      // 获取农历信息
      getLunarInfo(y,m,d){
        let lunarInfo=calendar.solar2lunar(y,m+1,d)
        let lunarValue=lunarInfo.IDayCn
        //console.log(lunarInfo,12313)
        return {
          IMonthCn:lunarInfo.IMonthCn,
          IDayCn:lunarInfo.IDayCn,
        }
      },
    },
    watch: {
      nowMonth (val) {
        this.impotTime = val;
        this.init()
      },
      defaultDate (val) {
        this.chooseInfo = val;
      },
    }
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
 .calendar{
   width: 100%;
   min-width:300px;
   background: #fff;
   /*padding: 0 .2rem;*/
   overflow: hidden;
 }
  .calendar table {
    clear: both;
    width: 100%;
    margin-bottom:10px;
    border-collapse: collapse;
    color: #444444;
    text-align: center;
    @include sc(.32rem,#999999);
    line-height: .8rem;

  }
  .calendar{
    thead{
      border-bottom: .02rem solid #eee;
      td{
        @include sc(.28rem,#ccc);
        &.dayofrest{
          color: #2EBE59;
        }
      }
    }
    tbody{
      td{
        position: relative;
      }
      .g-daybox{
        position: relative;
        margin: 0 auto;
        @include wh(.78rem,.8rem);
        @include sc(.28rem,#333);
        i{
          position: absolute;
          color: #35B665;
          font-size: .28rem;
          right: .1rem;
          bottom: -.2rem;
          display: none;
        }
      }
      .f-onNowDate{
        @include sc(.28rem,#686868);
        border-radius: .08rem;
        background: #EAEAEA;
      }
      .f-isAfterTomorrow,.f-Tomorrow{
        @include sc(.28rem,#686868);
      }
      .f-dayofrest{
        color: #2EBE59;
      }
      .f-isBeforeDate{
        //color: #ccc;
      }
      .f-onSign{
        @include sc(.28rem,#fff);
        border-radius: .08rem;
        background: #D60000;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// calendarDate.vue?fa896c64